import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../theme/colors';

export const useCourierStatusBadgeStyles = makeStyles(() => ({
  /**
   * A thin pill around the badge and chevron together, so the whole thing reads as the control.
   *
   * Inline-flex so it is only as wide as what it holds; a block would stretch across the column.
   */
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 8px 3px 3px',
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: '999px',
    // Barely there: lifts the control off the header without committing to a colour.
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    cursor: 'pointer',
    outline: 'none',
    '&:hover': {
      borderColor: Colors.midLightGray
    },
    '&:focus-visible': {
      borderColor: Colors.midLightGray
    }
  },
  chevron: {
    marginLeft: '4px',
    fontSize: '20px',
    color: Colors.midGray
  }
}));
